<template>
<div class="container">
  <div class="formulario">
    <div class="titulo">
      <h2>{{ titulo }}</h2>
    </div>

    <div class="dadosRequerimento">

      <!-- <b-card header="Acompanhamento da Solicitação" header-text-variant="white" header-tag="header" header-bg-variant="dark" footer-bg-variant="success" footer-border-variant="dark" class="formulario"> -->
        <validation-observer ref="observer">

          <b-form @submit.prevent="submit">

            <b-alert class="negrito" show><b-icon icon="file-earmark-text"  class="mr-1" />Acompanhamento do Requerimento</b-alert>

            <div>
              <b-form-group id="numeroSolicitacao" label="Digite o código do Requerimento" label-for="numeroSolicitacao">
                <validation-provider name="Código da Solicitação" rules="required" v-slot="validationContext">
                  <b-form-input id="numeroSolicitacao" v-model="form.numeroSolicitacao" type="text" :state="getValidationState(validationContext)"></b-form-input>
                  <b-form-invalid-feedback id="input-codigo-solicitacao-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </div>
            <vue-recaptcha
              ref="recaptcha"
              sitekey="6LcFQ9ohAAAAANm-_g2_YHW3ZTFjxt24oZc-n5G8"
              theme="light"
              @verify="pesquisaSolicitacao"
              size="invisible"
            > </vue-recaptcha>

            <!-- 6LcFQ9ohAAAAANm-_g2_YHW3ZTFjxt24oZc-n5G8  sitekey para mpt.mp.br v3 -->
            <!-- 6LeupMMhAAAAALkfXZQ7isrox5l75rGzytXytSUO  sitekey para localhost v3 -->
            <!-- 6LcxnKUhAAAAAFxT2g7YfeGP5zq3fnpYYfG0F2Dx  sitekey para localhost   -->
            <!-- 6Ld30qkhAAAAAIVdOaEIwRKuk1udIqei5rgYif06  sitekey para mpt.mp.br   -->
            <b-button type="submit" variant="primary">Enviar</b-button>
          </b-form>
        </validation-observer>
    </div>
  </div>
</div>
</template>

<script>
import api from '../api'
import { VueRecaptcha } from 'vue-recaptcha';
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import {
  required
} from 'vee-validate/dist/rules';
localize("pt_BR", pt_BR);
extend('required', required);

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha
  },
  data() {
    return {
      titulo: 'Requerimento LGPD - MPT',
      form: {
        numeroSolicitacao: '',
      },
      formJson: {},
      formTeste: {},
    }
  },

  methods: {

    getValidationState({
      dirty,
      validated,
      valid = null
    }) {
      return dirty || validated ? valid : null;
    },

    submit() {
      this.$refs.recaptcha.execute()
    },

    pesquisaSolicitacao(response) {
      this.formJson.numeroSolicitacao = this.form.numeroSolicitacao,
      console.log(response)

      this.$refs.observer.validate().then(success => {

        if (!success) {
          return;
        }      

        api
          .post("/tokenacesso", this.formJson, {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "x-access-token": response,
            },
          })
          .then(res => {
              if (res.status === 201) {
                this.$bvModal.msgBoxOk('✔️Foi gerado um token de acesso e enviado ao e-mail cadastrado.\n\nEste token tem validade de 3 horas.', {
                  title: 'Token gerado',
                  size: 'sm',
                  buttonSize: 'sm',
                  headerClass: 'p-2 border-bottom-0',
                  footerClass: 'p-2 border-top-0',
                  centered: true
                })
              } else if (res.status === 204) {
                this.$bvModal.msgBoxOk('❌Verifique o código de acompanhamento', {
                  title: 'Código não encontrado',
                  size: 'sm',
                  buttonSize: 'sm',
                  headerClass: 'p-2 border-bottom-0',
                  footerClass: 'p-2 border-top-0',
                  centered: true
                })             
              }
            },
            err => {
              this.$bvModal.msgBoxOk('❌Tente mais tarde', {
                title: 'Falha no envio do Requerimento',
                size: 'sm',
                buttonSize: 'sm',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
              })
            })
      })      
    },
  }
}
</script>

<style scoped>
.formulario {
  width: 80%;
  margin: auto;
  background-color: #f8f9fa !important;
  min-height: 100vh;
}

.titulo {
  margin-top: 20px;
  margin-bottom: 6em;

}

label.d-block {
  font-weight: bold;
}

.container {
  margin: 0px;
  background-color: #f8f9fa !important;
}

.negrito {
  font-weight: bold;
}

.custom-file-input {
  /* opacity: 100; */
}

.alert-info {
  background-color: transparent;
  border-color: transparent;
}

.alert {
  padding: 0px;
}

.dadosRequerimento {
  background-color: white;
  padding-top: 2em;
  padding-left: 2em;
  padding-right: 2em;
}

@media (max-width: 678px) {
  .titulo {
    margin-bottom: 0px;
  }

  .titulo h2{
    font-size: 1.5rem;
  }
}

.modal-body {
  white-space:break-spaces;
}


.modal-content {
  width: fit-content!important;
}


</style>



// WEBPACK FOOTER //
// src/views/AcompanhamentoRequerimento.vue